import { faqData } from '@/mocks/homeData';

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
            <i className="ri-question-answer-line mr-1"></i>答疑解惑
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            常见问答
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            关于黑料每日大赛，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-3">
                {faq.question}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}